import React from "react";
import PropTypes from "prop-types";

const SelectArray = (props) => {

  const {
    label = '',
    name = '',
    value = '',
    className = '',
    data = [],
    hasError = false,
    onChange = () => {},
    error = '',
    isLoading,
    disabled = false,
    dataValueKey = 'value',
    dataLabelKey = 'label',
  } = props

  return (
    <div className={className + 'select-array '}>
      <label>{label}
        {hasError && <span className="error"> - {error}</span>}
        <div className="form-row">
          <select
            disabled={isLoading || disabled}
            name={name}
            value={value}
            onChange={onChange}
          >
            {data.map((item, index) => {
                return (
                  <option key={index} value={item[dataValueKey]}>{item[dataLabelKey]}</option>
                )
              }
            )}
          </select>
        </div>
      </label>
    </div>
  )
}

SelectArray.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.array,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
  dataValueKey: PropTypes.string,
  dataLabelKey: PropTypes.string,
}

export default SelectArray
